import React from "react";
import PropTypes from "prop-types";
import { intlShape } from "react-intl";
import StandardMoney from "../../../common/StandardMoney";

const tableCellStyle = {
  width: "50%",
  paddingTop: "10px",
  paddingBottom: "10px",
  paddingLeft: "15px",
  paddingRight: "15px",
  fontWeight: "bold",
};
const SubCategoryInfo = ({ data, currencyCode, intl }) => {
  return (
    <div key={data.subCategoryName} style={{ marginTop: "1.6em" }}>
      <p style={{ fontSize: "1.125em" }}>
        <strong>
          {intl.formatMessage({
            id: data.subCategoryName,
            defaultMessage: data.subCategoryName,
          })}
        </strong>
      </p>
      <table style={{ width: "100%" }}>
        <tbody>
          {data.subSubCategoryList &&
            data.subSubCategoryList.map(item => {
              return (
                <tr key={item.subSubCategoryName}>
                  <td style={tableCellStyle}>
                    <strong>
                      {intl.formatMessage({
                        id: item.subSubCategoryName,
                        defaultMessage: item.subSubCategoryName,
                      })}
                    </strong>
                  </td>
                  <td style={tableCellStyle}>
                    <strong>
                      {Number(item.entitlement) > 0 ? (
                        <StandardMoney value={item.entitlement} currency={currencyCode} />
                      ) : (
                        item.entitlement
                      )}
                    </strong>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>

      <p style={{ marginTop: "0.75em", fontSize: "0.875em" }}>
        {intl.formatMessage({
          id: data.subCategoryFootNotes,
          defaultMessage: data.subCategoryFootNotes,
        })}
      </p>
    </div>
  );
};

SubCategoryInfo.propTypes = {
  data: PropTypes.object,
  currencyCode: PropTypes.string,
  intl: intlShape.isRequired,
};

export default SubCategoryInfo;



// WEBPACK FOOTER //
// ./components/employee/benefits/trs/SubCategoryInfo.jsx